import React from 'react'
import { Link } from 'react-router-dom';
import Footer from '../../../../Layout/Footer';
import Header from '../../../../Layout/Header';
import feedback from '../../../../../assets/img/notify.jpg';

const MytaskHistorySeller = () => {
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>My Task </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Task Details</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="mytask-details">
                <div className="container">
                    <div className="row task-history-main">
                        <div className="member">
                            <div className="pic"><img src={feedback} className="img-fluid" alt="" /></div>
                            <div className="member-info">
                                <h4>Firoz</h4>
                                <p>1.0 <i class="bi bi-star-fill"></i> 5000 Rating</p>
                            </div>

                        </div>
                        <div className='member-details'>
                            <h4>Experience: 2.0</h4>
                            <h4>Bio: Test</h4>
                            <h4>Customer Rating:</h4>
                            <div className='border-bottom-experience'>
                                <span className="badge badge-light-warning">1.0 <i class="bi bi-star-fill"></i></span>
                                <p className='mt-2'>Test</p>
                            </div>
                            <div className='border-bottom-experience'>
                                <span className="badge badge-light-warning">1.0 <i class="bi bi-star-fill"></i></span>
                                <p className='mt-2'>Test</p>
                            </div>
                        </div>
                        <div className='member-details-hist'>
                            <div className='service-history'>
                                <div className='member-details-left'>
                                    <h4>Service History</h4>
                                    <p>Gst testing</p>
                                    <p>Buyer: Kaveri</p>
                                    <p>Testjhlihi</p>
                                </div>
                                <div className='member-details-right'>
                                    <p className='bid-rate'>Bid rate: 20.0</p>
                                    <p className='completed'><i class="bi bi-check-circle"></i> Completed</p>
                                </div>
                            </div>

                        </div>
                        <div className='member-details-hist'>
                            <div className='service-history'>
                                <div className='member-details-left'>
                                    <h4>Service History</h4>
                                    <p>Gst testing</p>
                                    <p>Buyer: Kaveri</p>
                                    <p>Testjhlihi</p>
                                </div>
                                <div className='member-details-right'>
                                    <p className='bid-rate'>Bid rate: 20.0</p>
                                    <p className='completed'><i class="bi bi-check-circle"></i> Completed</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default MytaskHistorySeller;